#!/usr/bin/env node

import { pullTranslationsFromSmartling } from './pull-client.js';

await pullTranslationsFromSmartling();
